(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    // 
    //

  function pxWorkstationCreateNetwork(
    $http, toastr, $filter
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        tenant: '=tenant',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/workstationProperties/workstationSettings/workstationCreateNetwork/workstationCreateNetwork.template.html',
      link: function(scope) {


        var ip_regex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/i;

        scope.newNetwork = {
          name: '',
          gatewayIp: ''
        }
        scope.validForm = false;
        scope.ipAddressInvalid = true;
        scope.networkNameInvalid = true;

        scope.validateForm = function () { 
          var ip =  angular.copy(scope.newNetwork.gatewayIp);
          var networkName = angular.copy(scope.newNetwork.name);

          if (ip && ip_regex.test(ip)) {
            scope.ipAddressInvalid = false;
          } else {
            scope.ipAddressInvalid = true;
          }

          if (networkName) {
            scope.networkNameInvalid = false;
          } else {
            scope.networkNameInvalid = true;
          }

          if (!scope.networkNameInvalid && !scope.ipAddressInvalid) {
            scope.validForm = true;
          } else {
            scope.validForm = false;
          }
        }

        scope.addNewVirtualNetwork = function () {
          var url = scope.context.workstation.info._links['px:createZeroTrustNetwork'].href + '?name=' + scope.newNetwork.name + '&gatewayIp=' + scope.newNetwork.gatewayIp;
          $http.post(url).then(function(response) {
            toastr.success($filter('translate')('ChangesSaved'))
          }).catch(function(error){
            toastr.error($filter('translate')('ERROR'))
          });
          scope.callback();
        }

      }
    };
  }

  pxWorkstationCreateNetwork.$inject = ['$http', 'toastr', '$filter'];

  angular
    .module('printix-admin')
    .directive('pxWorkstationCreateNetwork', pxWorkstationCreateNetwork);

})();
